import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBuildingsDeselect } from "../../../player-base/buildings/actionBuildings";
import { actionInventoryInfoRemoveResource } from "../../inventory/actionInventoryInfo";
import { actionPlayerInfoAddXp } from "../../player/actionPlayerInfo";
import { actionProductionUpdate } from "../actionProductionInfo";
export var pathProductionBoost = function (action, state$, deps) {
    var state = state$.value;
    var recipeCostToItemParam = function (val) { return ({
        amount: val.amount,
        typeId: val.id,
    }); };
    return deps
        .netSend({
        id: CommandCode.BoostProduce,
        props: {
            boostId: action.recipe.recipe.id,
            buildingId: action.building.proto.id,
            farmId: state.playerBase.base.baseId,
            playerId: state.playerInfo.playerId,
        },
    })
        .pipe(retry(), switchMap(function (res) {
        return from([
            actionInventoryInfoRemoveResource(action.recipe.cost.map(recipeCostToItemParam)),
            actionProductionUpdate(action.building.proto.id, res.production),
            actionPlayerInfoAddXp(res.xp),
            actionBuildingsDeselect(),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/path/pathProductionBoost.ts
// module id = 1944
// module chunks = 3